export enum GeometryType {
  none = "none",
  plane = "plane",
  cone = "cone",
  box = "box",
  sphere = "sphere",
  cylinder = "cylinder",
  buffer = "buffer",
}
